module.exports = __webpack_public_path__ + "img/events.4ed9b61.svg";